import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { UPDATE_ACCOUNT_USER, NAME } from './constants';

import alo from './alo';
import iban from './iban';
import gains from './gains';
import myebons from './ebons';
import balance from './balance';
import password from './password';
import identity from './identity';
import mycashback from './cashback';
import myprofile from './myprofile';
import mymessages from './mymessages';
import myinterests from './myinterests';
import paymentrequest from './paymentrequest';

const user = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_ACCOUNT_USER:
            return action.user;
        default:
            return state;
    }
};

// Persist only token
const accountPersistConfig = {
    key: NAME,
    storage: storage,
    whitelist: ['user']
};

const reducer = combineReducers({
    user,
    [alo.constants.NAME]: alo.reducer,
    [balance.constants.NAME]: balance.reducer,
    [gains.constants.NAME]: gains.reducer,
    [iban.constants.NAME]: iban.reducer,
    [identity.constants.NAME]: identity.reducer,
    [mycashback.constants.NAME]: mycashback.reducer,
    [myebons.constants.NAME]: myebons.reducer,
    [myinterests.constants.NAME]: myinterests.reducer,
    [mymessages.constants.NAME]: mymessages.reducer,
    [myprofile.constants.NAME]: myprofile.reducer,
    [password.constants.NAME]: password.reducer,
    [paymentrequest.constants.NAME]: paymentrequest.reducer
});

export default persistReducer(accountPersistConfig, reducer);



// WEBPACK FOOTER //
// ./src/services/account/reducer.js